import React, { useEffect, useState } from "react";

/**
 * Defer brainstorm routes until after mount so BrainstormProvider's runtime
 * config is registered before the hub loads recent conversations (avoids a
 * first-visit race with React StrictMode in development).
 */
export default function BrainstormReadyGate({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return null;
  }

  return children;
}
